/* import __COLOCATED_TEMPLATE__ from './anchor-link-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();